import { bindTokenProvider, createHttpClient, session } from '@/core';

/**
 * HTTP 装配点（录单端）— **只剩真实后端运行档**（《前端项目开发文档》§3.5 的 ②③ 两档）。
 *
 * | 档位 | 变量 | 行为 |
 * |---|---|---|
 * | ① 直连 | `VITE_API_BASE_URL=http://<host>:<port>` | 真实请求，**不拼 /api** |
 * | ② 代理 | `VITE_API_BASE_URL=/api`（或留空）+ `VITE_API_PROXY=true` | 由 vite `server.proxy` 把 `/api` 转发到后端根 |
 *
 * 端内差异只有一处：401 回跳的兜底路径是本端落地页 `/intake`，不是管理端 `/dashboard`。
 * 档① 的「浏览器不可用」结论观测于 commit `0d6dc24`（带 Origin 的请求不下发任何
 * `Access-Control-Allow-*`，详见协同裁定 §I，修法在后端配置侧）；当前部署 `ba9cfb7` 未复测——
 * seq343 已裁定「前端不要为 CORS 做任何改动」，故开发默认仍走档②。
 *
 * t42：契约 mock 档与回落桩数据集整体删除，本端一律打真实后端；
 * 缺口回落桩亦按用户 m00124 裁定整体下线：后端未部署的端点回 404/405 时**直接向上抛错**，
 * 本端不再回任何桩数据；帮助页那类「有本端静态兜底」的视图由调用方自行回落，不经 HTTP 层。
 * 断言层 `src/__assert__/noMockRuntime.assert.ts` 把 mock 与回落桩两套符号一起拒，禁止再接回来。
 */

/** 本端落地页：会话失效后回跳仍应回到录单位置，而不是管理端看板 */
const HOME = '/intake';

/** 401：清会话 + 跳登录（带 redirect 回跳），由路由守卫兜底 */
bindTokenProvider({
  getAccessToken: () => session.getAccessToken(),
  onUnauthorized: () => {
    session.clearSession();
    const current = window.location.hash.replace(/^#/, '');
    // 登录页自身 401（凭证错误）不得回跳成 /login?redirect=/login，否则刷新即自环
    const redirect = encodeURIComponent(current && current !== '/login' ? current : HOME);
    window.location.hash = `#/login?redirect=${redirect}&reason=session`;
  },
});

/** 不传 adapter（走 axios 默认实现）也不装回落桩拦截器：本端只打真实后端 */
export const http = createHttpClient();

export { getContractDrift } from '@/core';

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '(同源 → dev proxy)';
